import React from 'react';
import { motion } from 'framer-motion';
import './Overlays.css'

const SUIT_SYM  = { S: '♠', H: '♥', D: '♦', C: '♣' };
const SUIT_NAME = { S: 'SPADES', H: 'HEARTS', D: 'DIAMONDS', C: 'CLUBS' };

export default function TrumpRevealOverlay({ gs, active }) {
  if (!active || gs.royal_pair_team !== -1 || !gs.trump_revealed) return null;

  const suit = gs.trump;

  return (
    <div className="trump-reveal-v2-container">
      <motion.div 
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 1.1 }}
        className={`trump-reveal-v2-card suit-${suit}`}
      >
        <div className="reveal-shimmer" />
        <div className="reveal-content">
          <motion.div 
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="reveal-label"
          >
            TRUMP REVEALED
          </motion.div>
          
          <motion.div 
            initial={{ scale: 0.5, rotate: -45, opacity: 0 }}
            animate={{ scale: 1, rotate: 0, opacity: 1 }}
            transition={{ type: 'spring', damping: 12, delay: 0.3 }}
            className="reveal-suit-symbol"
          >
            {SUIT_SYM[suit]}
          </motion.div>

          <motion.div 
            initial={{ y: -10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="reveal-suit-name-v2"
          >
            {SUIT_NAME[suit]}
          </motion.div>
        </div>
        <div className="reveal-border-glow" />
      </motion.div>
    </div>
  );
}
